import React from "react";
import { classNames } from "../../helpers/classNames";

const FaqLoader = () => {
  return (
    <div>
      <div className="flex-grow">
        <div className="space-y-4">
          <div className="rounded overflow-hidden h-10 w-full bg-[#d4d4d4]">
            <div
              className={classNames(
                "w-full h-full relative before bg-gradient-to-r from-transparent via-gray-100/90 to-transparent -translate-x-full animate-[shimmer_2s_infinite]",
                "via-[#a3a3a3]/60"
              )}
            ></div>
          </div>
          <div className="rounded overflow-hidden h-10 w-full bg-[#d4d4d4]">
            <div
              className={classNames(
                "w-full h-full relative before bg-gradient-to-r from-transparent via-gray-100/90 to-transparent -translate-x-full animate-[shimmer_2s_infinite]",
                "via-[#a3a3a3]/60"
              )}
            ></div>
          </div>
          <div className="rounded overflow-hidden h-10 w-full bg-[#d4d4d4]">
            <div
              className={classNames(
                "w-full h-full relative before bg-gradient-to-r from-transparent via-gray-100/90 to-transparent -translate-x-full animate-[shimmer_2s_infinite]",
                "via-[#a3a3a3]/60"
              )}
            ></div>
          </div>
          <div className="rounded overflow-hidden h-10 w-full bg-[#d4d4d4]">
            <div
              className={classNames(
                "w-full h-full relative before bg-gradient-to-r from-transparent via-gray-100/90 to-transparent -translate-x-full animate-[shimmer_2s_infinite]",
                "via-[#a3a3a3]/60"
              )}
            ></div>
          </div>
          <div className="rounded overflow-hidden h-10 w-full bg-[#d4d4d4]">
            <div
              className={classNames(
                "w-full h-full relative before bg-gradient-to-r from-transparent via-gray-100/90 to-transparent -translate-x-full animate-[shimmer_2s_infinite]",
                "via-[#a3a3a3]/60"
              )}
            ></div>
          </div>
          <div className="rounded overflow-hidden h-10 w-full bg-[#d4d4d4]">
            <div
              className={classNames(
                "w-full h-full relative before bg-gradient-to-r from-transparent via-gray-100/90 to-transparent -translate-x-full animate-[shimmer_2s_infinite]",
                "via-[#a3a3a3]/60"
              )}
            ></div>
          </div>
          <div className="rounded overflow-hidden h-10 w-full bg-[#d4d4d4]">
            <div
              className={classNames(
                "w-full h-full relative before bg-gradient-to-r from-transparent via-gray-100/90 to-transparent -translate-x-full animate-[shimmer_2s_infinite]",
                "via-[#a3a3a3]/60"
              )}
            ></div>
          </div>
          <div className="rounded overflow-hidden h-10 w-full bg-[#d4d4d4]">
            <div
              className={classNames(
                "w-full h-full relative before bg-gradient-to-r from-transparent via-gray-100/90 to-transparent -translate-x-full animate-[shimmer_2s_infinite]",
                "via-[#a3a3a3]/60"
              )}
            ></div>
          </div>
          <div className="rounded overflow-hidden h-10 w-full bg-[#d4d4d4]">
            <div
              className={classNames(
                "w-full h-full relative before bg-gradient-to-r from-transparent via-gray-100/90 to-transparent -translate-x-full animate-[shimmer_2s_infinite]",
                "via-[#a3a3a3]/60"
              )}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FaqLoader;
